var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrustedRelation2X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/34px/Custom/Trusted Relation@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    rx: 4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/34px/Custom/Trusted-Relation",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arch-Category_Customer-Enablement_64"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#658BD3",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5, 4.2109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uF2F7",
    transform: "translate(7.3981, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.83095703,1.45499361 L4.49345703,0.0643686056 C4.40871582,0.0290640116 4.26469916,0 4.17291793,0 C4.08058049,0 3.93738076,0.0290640116 3.85203136,0.0643686056 L0.514705089,1.45499361 C0.203378853,1.58345284 0,1.88765206 0,2.20923409 C0,6.69573811 3.28882807,8.89987852 4.17013661,8.89987852 C5.06013682,8.89987852 8.34375,6.67140175 8.34375,2.20923409 C8.34375,1.88765206 8.14037088,1.58345284 7.83095703,1.45499361 Z M5.840625,3.47644102 C5.840625,3.57258546 5.80758026,3.66921635 5.74013486,3.74796047 L4.07138486,5.69483547 C3.95458984,5.83181211 3.79988292,5.82485909 3.7546875,5.82485909 C3.64441104,5.82485909 3.53792381,5.78086309 3.45970115,5.70264044 L2.62532615,4.86826544 C2.54310552,4.8027494 2.503125,4.69497628 2.503125,4.57329659 C2.503125,4.35097054 2.68216802,4.15610909 2.9203125,4.15610909 C3.02706046,4.15610909 3.13377342,4.19685431 3.21529885,4.27832775 L3.73139459,4.7944235 L5.10689663,3.18929465 C5.18962148,3.09313324 5.30645151,3.04393958 5.42395896,3.04393958 C5.74328114,3.05925352 5.840625,3.34780831 5.840625,3.47644102 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uF4C6",
    transform: "translate(0, 11.4426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6325783,5.33304666 L10.5896096,6.28875389 C9.178125,7.58238302 7.57195323,6.70281208 7.0539451,6.13960959 C6.11875,5.11749989 6.19175802,3.53566449 7.20691417,2.6039451 L10.0507424,0 L9.82128906,0 C7.81183583,0 5.8788674,0.797871518 4.45695302,2.21804645 L1.1125,2.22847677 C0.500624788,2.22847677 0,2.72875357 0,3.34028184 L0,8.89582829 C0,9.50735551 0.500624788,10.0097192 1.08121062,10.0097192 L5.05492219,10.0076196 L8.20121126,12.8521433 C9.15726647,13.6298501 10.5565829,13.4817482 11.330118,12.5303872 L11.960071,13.060563 C12.5121493,13.4812273 13.3291415,13.4256021 13.7810946,12.8739068 L14.8720401,11.5319535 L15.0588703,11.6883287 C15.5368976,12.0707506 16.2367298,12.0012894 16.6233234,11.523262 L16.9562387,11.1119852 C17.3414413,10.6356957 17.2683993,9.93864533 16.7928059,9.55239868 L11.6325783,5.33304666 Z M21.1375,2.22847677 L17.8,2.22410667 C16.3753043,0.800106966 14.4430313,0.00327837467 12.4287109,0.00327837467 L12.1297264,0 C11.8516014,0 11.5866875,0.111145389 11.3780937,0.297871637 L7.96132813,3.41746051 C7.95785135,3.42441406 7.95437511,3.43136761 7.95437511,3.43136761 C7.3703125,3.98066406 7.38421854,4.84285167 7.87789084,5.37824208 C8.21250998,5.74328114 9.09468771,6.12987472 9.82928554,5.47384755 C9.82928554,5.46950185 9.83797694,5.46950185 9.84232265,5.46515614 L12.6235726,2.92378927 C12.8495492,2.71968021 13.2013772,2.73271732 13.4099709,2.9585549 C13.6185647,3.18439248 13.6011819,3.53635942 13.3752053,3.74495317 L12.4671273,4.57480847 L17.5290025,8.68062899 C17.9503618,9.02800727 18.2069322,9.49727318 18.298018,10.0010278 L21.1375,10.0020707 C21.7493742,10.0020707 22.25,9.50214088 22.25,8.89026567 L22.25,3.34097677 C22.25,2.72562479 21.752852,2.22847677 21.1375,2.22847677 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustedRelation2X);
export default __webpack_public_path__ + "static/media/Trusted Relation@2x.e67cba9014313b01687e30a6e4c34496.svg";
export { ForwardRef as ReactComponent };